import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createReportActions } from './actions';
import { ReportActions, ReportState } from './types';

export const useReportStore = create<ReportState & ReportActions>()(
    immer((set, get, store) => ({
        reports: [],
        loading: false,
        selectedReport: null,
        loadingReport: false,
        error: undefined,
        ...createReportActions(set, get, store),
    })),
);
